import { Component, Input } from '@angular/core';
import { environment } from '@env/environment';
import { CountryCodeService } from 'src/app/services/country-code.service';

@Component({
    selector: 'order-notes',
    templateUrl: './order-notes.component.html',
    styleUrls: ['./order-notes.component.scss']
})
export class OrderNotesComponent {
    @Input() notes: any;

    constructor(
        private countryCodeService: CountryCodeService
    ) { }

    baseUrl = environment.BASE_PATH;

    replaceWithDefaultAvatar(event: any): void {
        event.target.src = 'assets/images/default_user_avatar.png';
    }

    getUTCUser(): string {
        return this.countryCodeService.getUTCOffset();
    }
}